import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Filter } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const EmailAttributeFilterNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data.label || "Email Filter"}
            icon={Filter}
            colorClass="text-orange-600"
            bgClass="bg-orange-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(EmailAttributeFilterNode);
